import { DataModel } from "common/models/utility-models/base-model";

export class UnassignInternshipModel extends DataModel {
    override id: any = '';
    internshipUnassignedReason: any = '';
}